import { getTempEnvParam } from 'env'

/**
 * 리소스 레코드(`GET /v1/resources/bulk` 의 `data[]`)로 복호 객체를 만든다.
 *
 * 🛑 **원래 `pages/records/components/RecordCardContent.js` 에 있었다** (PR 7-a Task A0).
 * 옮긴 이유는 동작이 아니라 **의존 무게**다 — 그 파일은 React·antd·react-i18next·scss·svg 등
 * 17개를 끌고 오고, 그 체인 안에 jest 파싱을 깨뜨리는 ESM 의존이 있다
 * (`utils/importExport/__tests__/totpDuplicateCheck.test.js:12` 이 이 모듈을 통째로 mock 하는 이유).
 * `redux/user/sagas.js` 가 언락 직후 스윕을 부르므로 그 체인이 redux 계층에 딸려 오면 안 된다.
 * 원래 자리에는 re-export 를 남겨 기존 호출부·mock 이 그대로 동작한다.
 *
 * 🛑 **`data.resource_key` 가 없으면 인자 없는 `createRSKeyObj()` 로 간다** — 그것은
 * `createRsKey()`(`pUtils.js`, `forge.random.getBytesSync(32)`)로 **새 랜덤 키를 만든다.**
 * 호출부가 그 레코드를 걸러야 한다 (설계 F9 — `services/vaultV2/sweepRunner.js` 의 가드).
 * `group_key` 는 **리소스 키를 누가 푸느냐**만 정하고 키 자체를 주지 않으므로 이 판정과 무관하다.
 */
export const getRsKeyObjFromResource = async (data) => {
  let rsaEncDec = getTempEnvParam('rsaObj')

  if (data != null && data.group_key != null) {
    const { user_group_key: encGroupKey, group_private_key: encPrivateKey } = data.group_key
    const groupInfo = {
      id: data.id,
      enc_group_key: encGroupKey,
      enc_private_key: encPrivateKey,
      name: data.title,
    }
    rsaEncDec = await rsaEncDec.getGroupObj(groupInfo)
  }

  let rsKeyObj = null

  if (data != null && data.resource_key != null) {
    rsKeyObj = rsaEncDec.createRSKeyObj(data.resource_key.key)
  } else {
    rsKeyObj = rsaEncDec.createRSKeyObj()
  }

  return rsKeyObj
}

export default getRsKeyObjFromResource
